import React, { Component } from "react";
import { Row, Col, Slider, Divider, DatePicker, Spin } from "antd";
import LineChart from "../elements/lineChart";
import { Line, Column } from "@ant-design/charts";
import "../styles/general.css";

import PieChart from "../elements/pieChart";
import GaugeChart from "../elements/gauge";
import { RingProgress } from "@ant-design/charts";
import { MakeRequestAsync } from "../functions/axios";
import { GET } from "../constants/request-type";
import { service_api } from "../constants/url";
import {
  deliverman,
  food,
  get_all_chef,
  get_all_company_glocery_item,
  get_all_deliverman,
  get_all_food,
  get_all_order,
  get_all_user,
  glocery_item,
  order,
  user
} from "../constants/routes";

import { decryptSingleData } from "../functions/cryptojs";
import { connect } from "react-redux";

const { RangePicker } = DatePicker;

const token = sessionStorage.getItem("auth_token");

const style2 = { background: "inherit", padding: "", height: 400 };

class Dashboard extends Component {
  state = {
    load: true,
    users: [],
    orders: [],
    support: [],
    delivermen: [],
    articles: [],
    resto: [],
    start: null,
    end: null
  };

  componentDidMount() {
    this.getData();
  }

  timeClosing = (opening, closing, receiving) => {
    const date = new Date();
    var time = date.getHours();
    console.log(time);

    if (
      time >= parseInt(opening) &&
      time < parseInt(closing) &&
      receiving === 0
    )
      return false;
    else return true;
  };

  getData = async () => {
    const request_details_article = {
      type: GET,
      url: service_api,
      route:
        glocery_item +
        "/" +
        get_all_company_glocery_item +
        "/" +
        this.props.admin._id,
      data: null,
      token: token
    };
    const request_details_order = {
      type: GET,
      url: service_api,
      route: "order-glocery/get-glocery-orders/" + this.props.admin._id,
      data: null,
      token: token
    };

    // const response_resto = await MakeRequestAsync(request_details_resto)
    //   .then((res) => {
    //     this.setState({
    //       resto: decryptSingleData(res?.data?.chef)
    //     });
    //   })
    //   .catch((err) => {
    //     // openNotificationWithIcon("error", `${err.response.data}`);
    //     return this.setState({ load: false });
    //   });

    const response_article = await MakeRequestAsync(request_details_article)
      .then((res) => {
        this.setState({
          articles: decryptSingleData(res.data?.glocery_item)
        });
      })
      .catch((err) => {
        // openNotificationWithIcon(
        //   "error",
        //   `${err?.response?.data?.message}`
        // );
        return this.setState({ load: false });
      });

    const response_order = await MakeRequestAsync(request_details_order)
      .then((res) => {
        this.setState({
          orders: decryptSingleData(res?.data?.order)
        });
      })
      .catch((err) => {
        // openNotificationWithIcon(
        //   "error",
        //   `${err?.response?.data?.message}`
        // );
        return this.setState({ load: false });
      });

    // const response_help = await MakeRequestAsync(request_details_help)
    //   .then((res) => {
    //     this.setState({
    //       support: res?.data
    //     });
    //   })
    //   .catch((err) => {
    //     // openNotificationWithIcon(
    //     //   "error",
    //     //   `${err?.response?.data?.message}`
    //     // );
    //     return this.setState({ load: false });
    //   });

    // console.log(decryptSingleData(response.data.branch));

    // console.log(response.data);
    this.setState({ load: false });
  };

  render() {
    const {
      load,
      users,
      resto,
      delivermen,
      orders,
      articles,
      support,
      start,
      end
    } = this.state;

    return load ? (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Spin size="large" />
      </div>
    ) : (
      <div style={{ width: "100%" }}>
        <Divider orientation="left" style={{}}>
          Filtre par intervale de date
        </Divider>
        <Row style={{}}>
          <RangePicker
            showTime
            onChange={(data) => {
              console.log(data);
              if (data === null) {
                return this.setState({
                  start: null,
                  end: null
                });
              }
              let d1 = data[0].format("YYYY-MM-DDTHH:mm:ss");
              let d2 = data[1].format("YYYY-MM-DDTHH:mm:ss");

              this.setState({ start: d1, end: d2 });
            }}
          />
        </Row>
        <Divider orientation="left" style={{}}>
          Statistiques
        </Divider>
        <Row
          gutter={16}
          style={{
            marginTop: 20
          }}
        >
          {[
            {
              name: "Articles",
              key: "articles",
              data: articles
            },
            {
              name: "Articles actifs",
              key: "articles-available",
              data: articles?.filter((res) => {
                return res.status === true && res.visible === true;
              })
            },
            {
              name: "Commandes",
              key: "orders",
              data: orders
            },
            {
              name: "Commandes en attente",
              key: "orders-waiting",
              data: orders?.filter((res) => {
                return res.status === 0;
              })
            },
            {
              name: "Commandes acceptées",
              key: "orders-accepted",
              data: orders?.filter((res) => {
                return res.status === 1;
              })
            },
            {
              name: "Commandes acceptées ayant livreur",
              key: "orders-accepted-deliverman",
              data: orders?.filter((res) => {
                return res.deliverman_id !== null;
              })
            },
            {
              name: "Commandes en chemin de livraison",
              key: "orders-onway",
              data: orders?.filter((res) => {
                return res.status === 2;
              })
            },
            {
              name: "Commandes livrées",
              key: "orders-delivered",
              data: orders?.filter((res) => {
                return res.status === 3;
              })
            },
            {
              name: "Commandes annulées",
              key: "orders-canceled",
              data: orders?.filter((res) => {
                return res.status === 4;
              })
            }
          ].map((e) => (
            <Col className="gutter-row" span={8} key={e.name}>
              <div
                style={{
                  background: "#fff",
                  // "-webkit-linear-gradient(right, #000,#E94E1B, #000)",
                  height: 150
                  // display: "flex",
                  // justifyContent: "space-around",
                  // alignItems: "center",
                  // flexDirection: "row",
                  // padding: "0 20px"
                }}
              >
                <p
                  style={{
                    fontSize: 26,
                    fontWeight: "500",
                    fontFamily: "arial",
                    marginTop: 5,
                    color: "#000"
                  }}
                >
                  {e?.name}
                </p>
                <p
                  style={{
                    color: "#000",
                    fontSize: 30,
                    fontFamily: "arial",
                    fontWeight: "bold",
                    marginTop: 5
                  }}
                >
                  {
                    e.data?.filter((item) => {
                      if (start === null || end === null) {
                        return item;
                      }
                      return item.createdAt >= start && item.createdAt <= end;
                    }).length
                  }
                </p>
              </div>
            </Col>
          ))}
        </Row>
        <Divider orientation="left" style={{}}>
          Gains en procédure (Commandes en cours)
        </Divider>
        <Row
          gutter={16}
          style={{
            marginTop: 20
          }}
        >
          {[
            {
              name: "Chiffre d'affaire",
              key: "order-ca-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status !== 3 && item.status !== 4;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status !== 3 &&
                    item.status !== 4
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return accumulator + currentObject?.billing_details?.amount;
                }, 0)
            },
            {
              name: "Gains (Mon shop)",
              key: "order-g-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status !== 3 && item.status !== 4;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status !== 3 &&
                    item.status !== 4
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return (
                    accumulator + currentObject?.billing_details?.earned_glocery
                  );
                }, 0)
            },
            {
              name: "Gain (Pani)",
              key: "order-net-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status !== 3 && item.status !== 4;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status !== 3 &&
                    item.status !== 4
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return (
                    accumulator + currentObject?.billing_details?.earned_pani
                  );
                }, 0)
            }
          ].map((e) => (
            <Col className="gutter-row" span={8} key={e.name}>
              <div
                style={{
                  background: "#de9a4c",
                  // "-webkit-linear-gradient(right, #000,#E94E1B, #000)",
                  height: 150
                  // display: "flex",
                  // justifyContent: "space-around",
                  // alignItems: "center",
                  // flexDirection: "row",
                  // padding: "0 20px"
                }}
              >
                <p
                  style={{
                    fontSize: 26,
                    fontWeight: "500",
                    fontFamily: "arial",
                    marginTop: 5,
                    color: "#fff"
                  }}
                >
                  {e?.name}
                </p>
                <p
                  style={{
                    color: "#fff",
                    fontSize: 26,
                    fontFamily: "arial",
                    fontWeight: "bold",
                    marginTop: 5,
                    color: "#fff"
                  }}
                >
                  ${e?.data?.toFixed(2)}
                </p>
              </div>
            </Col>
          ))}
        </Row>
        <Divider orientation="left" style={{}}>
          Gains Obtenus
        </Divider>
        <Row
          gutter={16}
          style={{
            marginTop: 20
          }}
        >
          {[
            {
              name: "Chiffre d'affaire",
              key: "order-ca-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status === 3;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status === 3
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return accumulator + currentObject?.billing_details?.amount;
                }, 0)
            },
            {
              name: "Gains (Mon store)",
              key: "order-g-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status === 3;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status === 3
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return (
                    accumulator + currentObject?.billing_details?.earned_glocery
                  );
                }, 0)
            },
            {
              name: "Gain (Pani)",
              key: "order-net-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status === 3;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status === 3
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return (
                    accumulator + currentObject?.billing_details?.earned_pani
                  );
                }, 0)
            }
          ].map((e) => (
            <Col className="gutter-row" span={8} key={e.name}>
              <div
                style={{
                  background: "#79CD3A",
                  // "-webkit-linear-gradient(right, #000,#E94E1B, #000)",
                  height: 150
                  // display: "flex",
                  // justifyContent: "space-around",
                  // alignItems: "center",
                  // flexDirection: "row",
                  // padding: "0 20px"
                }}
              >
                <p
                  style={{
                    fontSize: 26,
                    fontWeight: "500",
                    fontFamily: "arial",
                    marginTop: 5,
                    color: "#fff"
                  }}
                >
                  {e?.name}
                </p>
                <p
                  style={{
                    color: "#fff",
                    fontSize: 26,
                    fontFamily: "arial",
                    fontWeight: "bold",
                    marginTop: 5,
                    color: "#fff"
                  }}
                >
                  ${e?.data?.toFixed(2)}
                </p>
              </div>
            </Col>
          ))}
        </Row>

        <Divider orientation="left" style={{}}>
          Pertes (Commandes annulées)
        </Divider>
        <Row
          gutter={16}
          style={{
            marginTop: 20
          }}
        >
          {[
            {
              name: "Chiffre d'affaire",
              key: "order-ca-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status === 4;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status === 4
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return accumulator + currentObject?.billing_details?.amount;
                }, 0)
            },
            {
              name: "Gains (Mon store)",
              key: "order-g-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status === 4;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status === 4
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return (
                    accumulator + currentObject?.billing_details?.earned_glocery
                  );
                }, 0)
            },
            {
              name: "Gain (Pani)",
              key: "order-net-r",
              data: orders
                ?.filter((item) => {
                  if (start === null || end === null) {
                    return item.status === 4;
                  }
                  return (
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item.status === 4
                  );
                })
                ?.reduce((accumulator, currentObject) => {
                  return (
                    accumulator + currentObject?.billing_details?.earned_pani
                  );
                }, 0)
            }
          ].map((e) => (
            <Col className="gutter-row" span={8} key={e.name}>
              <div
                style={{
                  background: "#a41d1e",
                  // "-webkit-linear-gradient(right, #000,#E94E1B, #000)",
                  height: 150
                  // display: "flex",
                  // justifyContent: "space-around",
                  // alignItems: "center",
                  // flexDirection: "row",
                  // padding: "0 20px"
                }}
              >
                <p
                  style={{
                    fontSize: 26,
                    fontWeight: "500",
                    fontFamily: "arial",
                    marginTop: 5,
                    color: "#fff"
                  }}
                >
                  {e?.name}
                </p>
                <p
                  style={{
                    color: "#fff",
                    fontSize: 26,
                    fontFamily: "arial",
                    fontWeight: "bold",
                    marginTop: 5,
                    color: "#fff"
                  }}
                >
                  ${e?.data?.toFixed(2)}
                </p>
              </div>
            </Col>
          ))}
        </Row>

        <Divider orientation="left" style={{}}>
          Commandes (12 derniers mois)
        </Divider>
        <Row gutter={16}>
          <Col className="gutter-row" span={24}>
            <div style={{}}>
              <LineChart
                data={[
                  "01",
                  "02",
                  "03",
                  "04",
                  "05",
                  "06",
                  "07",
                  "08",
                  "09",
                  "10",
                  "11",
                  "12"
                ].map((item, index, array) => {
                  // get current year
                  const year = new Date().getFullYear();
                  // filter by month
                  const filtered = orders?.filter((data) => {
                    return data?.createdAt?.slice(0, 7) === year + "-" + item;
                  });

                  return {
                    days: year + "-" + item,
                    order: filtered?.length
                  };
                })}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchStoreToProps)(Dashboard);
